module.exports = __webpack_public_path__ + "static/media/WideCart_BG.aeef2f50.png";